export default __webpack_public_path__ + "static/media/kudos.d153eb32.svg";